import http from '@/http'

const URL = '/admin/cupons'

export const getCupons = (params) => http.get(URL, { params })

export const getCupon = (id) => http.get(`${URL}/${id}`)

export const createCupon = (data) => http.post(URL, data)

export const updateCupon = (id, data) => http.put(`${URL}/${id}`, data)

export const toggleCuponStatus = (id) => http.put(`${URL}/${id}/status`)

export const deleteCupon = (id) => http.delete(`${URL}/${id}`)

export const exportCupons = (params) => http.get(`${URL}/export`, { params, responseType: 'blob' })

export default {
  getCupons,
  getCupon,
  createCupon,
  updateCupon,
  toggleCuponStatus,
  deleteCupon,
  exportCupons
}
